var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  RELATIONAL_FUNCTIONS: () => RELATIONAL_FUNCTIONS,
  RELATIONAL_FUNCTION_TRANSLATE: () => RELATIONAL_FUNCTION_TRANSLATE,
  default: () => relational_default
});
var import_constants = __toModule(require("../../../../../engine/constants"));
var import_mathFunctionError = __toModule(require("../../../../../error/mathFunctionError"));
var import_math = __toModule(require("../helper/math"));
var import_utils = __toModule(require("../helper/utils"));
const RELATIONAL_FUNCTION_TRANSLATE = {
  "CONTIENE TEXTO": "containText",
  DISTINTO: "unequal",
  "DISTINTO TEXTO": "unequalText",
  IGUAL: "equal",
  "MISMO TEXTO": "equalText",
  MAYOR: "larger",
  "MAYOR O IGUAL": "largerEq",
  MENOR: "smaller",
  "MENOR O IGUAL": "smallerEq",
  "NO AUMENTA TAMA\xD1O MATRIZ": "hasNotMatrixLargerSizeChanged",
  "NO DISMINUYE TAMA\xD1O MATRIZ": "hasNotMatrixSmallerSizeChanged",
  "NO MODIFICA VALOR NUMERO": "hasNotValueChangedNumber",
  "NO HA MODIFICADO NUMERO": "hasNotChangedNumber",
  "NO MODIFICA VALOR TEXTO": "hasNotValueChangedText",
  "NO HA MODIFICADO TEXTO": "hasNotChangedText",
  "NO CONTIENE TEXTO": "notContainText"
};
const RELATIONAL_FUNCTIONS = Object.values(RELATIONAL_FUNCTION_TRANSLATE);
const containText = import_math.containTextFunction;
const equal = import_math.equalFunction;
const equalText = import_math.equalTextFunction;
const hasNotChanged = (args, math, scope, compareFunction, defaultValue) => {
  const originalScope = scope[import_constants.SCOPE_ORIGINAL] || {};
  const [currentArgs] = (0, import_utils.evalArgs)(args, scope, defaultValue, [defaultValue]);
  const [originalArgs] = (0, import_utils.evalArgs)(args, originalScope, defaultValue, [defaultValue]);
  const currentValues = (0, import_utils.simplify)(currentArgs);
  const originalValues = (0, import_utils.simplify)(originalArgs);
  if ((currentValues == null ? void 0 : currentValues.length) !== (originalValues == null ? void 0 : originalValues.length)) {
    return false;
  }
  const result = compareFunction(currentValues, originalValues);
  if (Array.isArray(result)) {
    return result.every((value) => value === true);
  }
  return result;
};
const hasNotValueChanged = (args, math, scope, compareFunction, defaultValue) => {
  const originalScope = scope[import_constants.SCOPE_ORIGINAL] || {};
  const [currentArgs, changeValueArgs] = (0, import_utils.evalArgs)(args, scope, defaultValue, [defaultValue]);
  if (!Array.isArray(changeValueArgs) || changeValueArgs.length !== 2) {
    throw new import_mathFunctionError.MathFunctionError(`Functions hasNotValueChanged requires an array of changes of length 2 actual: ${changeValueArgs}`);
  }
  const [originalArgs] = (0, import_utils.evalArgs)(args, originalScope, defaultValue, [defaultValue]);
  const currentValues = (0, import_utils.simplify)(currentArgs);
  const originalValues = (0, import_utils.simplify)(originalArgs);
  const originalResult = compareFunction(originalValues, changeValueArgs[0]);
  const currentResult = compareFunction(currentValues, changeValueArgs[1]);
  if (Array.isArray(currentResult)) {
    if (!Array.isArray(originalResult)) {
      return originalResult === false || currentResult.every((value) => value === false);
    }
    return currentResult.every((value, index) => {
      return !originalResult[index] || value === false;
    });
  }
  if (Array.isArray(originalResult)) {
    return currentResult === false || originalResult.every((value) => value === false);
  }
  return originalResult === false || currentResult === false;
};
const hasNotChangedNumber = (args, math, scope) => {
  return hasNotChanged(args, math, scope, equal, import_utils.ARG.SCALAR.NUMBER);
};
hasNotChangedNumber.rawArgs = true;
const hasNotChangedText = (args, math, scope) => {
  return hasNotChanged(args, math, scope, equalText, import_utils.ARG.SCALAR.STRING);
};
hasNotChangedText.rawArgs = true;
const hasNotValueChangedNumber = (args, math, scope) => {
  return hasNotValueChanged(args, math, scope, equal, import_utils.ARG.SCALAR.NUMBER);
};
hasNotValueChangedNumber.rawArgs = true;
const hasNotValueChangedText = (args, math, scope) => {
  return hasNotValueChanged(args, math, scope, equalText, import_utils.ARG.SCALAR.STRING);
};
hasNotValueChangedText.rawArgs = true;
const hasNotMatrixLargerSizeChanged = (args, math, scope) => {
  const originalScope = scope[import_constants.SCOPE_ORIGINAL] || {};
  const [currentArgs] = (0, import_utils.evalArgs)(args, scope);
  const [originalArgs] = (0, import_utils.evalArgs)(args, originalScope);
  const currentValues = Array.isArray(currentArgs) ? currentArgs : [currentArgs];
  const originalValues = Array.isArray(originalArgs) ? originalArgs : [originalArgs];
  if (originalArgs === void 0 && currentValues.length === 1 && currentValues[0] !== void 0) {
    return currentValues[0] === import_utils.ARG.SCALAR.STRING || currentValues[0] === import_utils.ARG.SCALAR.NUMBER;
  }
  return smallerEq(currentValues.length, originalValues.length);
};
hasNotMatrixLargerSizeChanged.rawArgs = true;
const hasNotMatrixSmallerSizeChanged = (args, math, scope) => {
  const originalScope = scope[import_constants.SCOPE_ORIGINAL] || {};
  const [currentArgs] = (0, import_utils.evalArgs)(args, scope);
  const [originalArgs] = (0, import_utils.evalArgs)(args, originalScope);
  const currentValues = Array.isArray(currentArgs) ? currentArgs : [currentArgs];
  const originalValues = Array.isArray(originalArgs) ? originalArgs : [originalArgs];
  if (currentArgs === void 0 && originalValues.length === 1 && originalValues[0] !== void 0) {
    return originalValues[0] === import_utils.ARG.SCALAR.STRING || originalValues[0] === import_utils.ARG.SCALAR.NUMBER;
  }
  return largerEq(currentValues.length, originalValues.length);
};
hasNotMatrixSmallerSizeChanged.rawArgs = true;
const ifThen = (args, math, scope) => {
  const [conditionalMatrixArg, ...valueArgs] = args.slice();
  const [conditionalMatrix] = (0, import_utils.evalArgs)([conditionalMatrixArg], scope, import_utils.ARG.MATRIX.BOOLEAN);
  if (!(0, import_utils.isCondition)(conditionalMatrix)) {
    if (!Array.isArray(conditionalMatrix)) {
      return (0, import_math.ifThenFunction)(conditionalMatrix);
    }
    return (0, import_utils.operateMatrices)(import_math.ifThenFunction, conditionalMatrix);
  }
  const values = (0, import_utils.evalArgs)(valueArgs, scope, import_utils.ARG.SCALAR.NUMBER, import_utils.ARG.MATRIX.NUMBER);
  if (!Array.isArray(conditionalMatrix)) {
    return (0, import_math.ifThenFunction)(conditionalMatrix, values[0]);
  }
  return (0, import_utils.operateMatrices)(import_math.ifThenFunction, conditionalMatrix, ...values);
};
ifThen.rawArgs = true;
const larger = import_math.largerFunction;
const largerEq = import_math.largerEqFunction;
const notContainText = import_math.notContainTextFunction;
const smaller = import_math.smallerFunction;
const smallerEq = import_math.smallerEqFunction;
const unequal = import_math.unequalFunction;
const unequalText = import_math.unequalTextFunction;
var relational_default = {
  containText,
  equal,
  equalText,
  hasNotChangedNumber,
  hasNotValueChangedNumber,
  hasNotChangedText,
  hasNotValueChangedText,
  hasNotMatrixLargerSizeChanged,
  hasNotMatrixSmallerSizeChanged,
  ifThen,
  larger,
  largerEq,
  notContainText,
  smaller,
  smallerEq,
  unequal,
  unequalText
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  RELATIONAL_FUNCTIONS,
  RELATIONAL_FUNCTION_TRANSLATE
});
